import React from "react";
import turnersLogo from '../images/TurnersInsurance_Logo.png';
import aaLogo from '../images/AA-logo-mbi.png';
import aaBubbleImage from '../images/AA Insurance_Bokeh2025.png';
import gaspyLogo from '../images/Gaspy-Logo.png';
import vtnzLogo from '../images/MBI-by-VTNZ-orange.png';
import autosureLogo from '../images/Autosure/autosure-logo.png';
import {Container} from "react-bootstrap";
import {useLocation} from "react-use";
import {detectSource} from "../utils/sourceDetection";

const HeaderTFAF = (props) => {
  const location = useLocation();
  const source = detectSource();

  return (

    <>
      <div style={{
        width: '100%',
        height: '100%',
        paddingTop: source === 'GASPY' || 'VTNZ' ? 5 : 20,
        background: 'white',
        boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.06)',
        justifyContent: 'space-between',
        alignItems: 'center',
        display: 'inline-flex'
      }}>
        <Container>
          {source === 'TFAF' &&
            <>
              <center><img src={turnersLogo} alt="turnersLogo" className='header-img'/></center>
              <br/>
            </>
          }
          {(source === 'AA' || source === 'AA_MEMBER') && <>
            <div className="column-on-mobile"
                 style={{display: "flex", justifyContent: 'space-between', maxHeight: '80px'}}>
              <div style={{position: 'relative', display: 'flex', alignItems: 'center'}}>
                <img
                  src={aaBubbleImage}
                  alt="bubble"
                  style={{
                    position: 'absolute',
                    top: '-160%',
                    left: '-45%',
                    transform: 'translateY(-50%)',
                    height: '400px',
                    width: 'auto',
                    zIndex: 1,
                    pointerEvents: 'none'
                  }}
                />
                <img
                  src={aaLogo}
                  alt="aaLogo"
                  className='header-img'
                  style={{
                    position: 'relative',
                    zIndex: 2,
                    marginLeft: '10px',
                    maxHeight: '50px',
                    width: 'auto'
                  }}
                />
              </div>
              <div style={{textAlign: 'right'}}>
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
                  {/*<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28"
                       style={{marginRight: '8px', zIndex: 2,}}>
                    <circle cx="14" cy="14" r="12" stroke="#0d59bf" strokeWidth="2" fill="#0d59bf"/>
                    <path
                      d="M10.5 8.5a1 1 0 0 1 1.4 0l1.3 1.3a1 1 0 0 1 0 1.4l-.5.5a.5.5 0 0 0-.1.6c.8 1.6 2 2.8 3.6 3.6a.5.5 0 0 0 .6-.1l.5-.5a1 1 0 0 1 1.4 0l1.3 1.3a1 1 0 0 1 0 1.4l-.6.6c-.6.6-1.4.9-2.3.7-2.6-.6-5.1-2.8-6.8-5.4-.7-1.1-1-2.3-.4-3.1l.6-.7z"
                      stroke="#3A7CA5"
                      strokeWidth="1.5"
                      fill="white"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>*/}
                  <svg width="15" height="15" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg"
                       style={{marginRight: '8px', zIndex: 2,}}>
                    <circle cx="14" cy="14" r="14" fill="#0d59bf"/>
                    <path
                      d="M 10 8 L 12 8 C 12.5 8 13 8.5 13 9 L 13 10.5 C 13 10.8 12.8 11 12.6 11.2 L 11 12.8 C 11 12.8 11.8 14.5 13.5 16.2 C 15.2 17.9 16.9 18.7 16.9 18.7 L 18.5 17.1 C 18.7 16.9 18.9 16.7 19.2 16.7 L 20.7 16.7 C 21.2 16.7 21.7 17.2 21.7 17.7 L 21.7 19.7 C 21.7 20.2 21.2 20.7 20.7 20.7 L 19.5 20.7 C 13 20.7 7.3 15 7.3 8.5 L 7.3 7.3 C 7.3 6.8 7.8 6.3 8.3 6.3 L 10 6.3 C 10.5 6.3 11 6.8 11 7.3 L 11 9 C 11 9.5 10.5 10 10 10 Z"
                      fill="white"/>
                  </svg>

                  <span className='spanLink mediumTextStyles' onClick={() => window.location = "tel:0800262411"}
                        style={{textDecoration: 'underline', zIndex: 2,}}>Call us on 0800 262 411</span>
                </div>
              </div>
            </div>
            <br/>
          </>
          }
          {(source === 'TFAF_AUTOSURE' || source === 'QUASHED') &&
            <>
              <center><img src={autosureLogo} alt="autosureLogo" className='header-img'/></center>
              <br/>
            </>
          }
          {source === 'MONEYHUB' &&
            <>
              <center><img src={autosureLogo} alt="autosureLogo" className='header-img'/></center>
              <br/>
            </>
          }
          {source === 'MYAUTOSHOP' &&
            <>
              <center><img src={autosureLogo} alt="autosureLogo" className='header-img'/></center>
              <br/>
            </>
          }
          {source === 'GASPY' &&
            <center><img src={gaspyLogo} style={{paddingBottom: '5px'}} alt="gaspyLogo" className='header-img'/>
            </center>
          }
          {source === 'VTNZ' &&
            <div style={{paddingTop: '30px', paddingBottom: '30px'}}>

              <center><img src={vtnzLogo} style={{maxHeight: "60px"}} alt="vtnzLogo" className='header-img'/>
              </center>
            </div>
          }
        </Container>
      </div>
    </>

  );
}

export default HeaderTFAF;
